<template>
  <Layout>



    <div class="card"  style="height: 100%;">

        <b-overlay :show="isLoading" rounded="sm">
          <div class="card-body">
            <div class="row">
              <div class="col-md-6">
                <h4>Registrar cuaderno de obra</h4>
              </div>
            </div>
            <div class="form-row">
              <div class="form-group col-md-9">
                <label>Expediente</label>
                <v-select
                    :options="expedientes"
                    label="obra_expediente"
                    :reduce="desc=>desc.expediente_id"
                    v-model="expediente_id"
                    @input="actualizar()"
                />

              </div>

              <div class="form-group col-md-3">
                <label>Fecha</label>
                <VueCtkDateTimePicker
                    v-model="fecha"
                    :locale="'es'"
                    :input-size="'sm'"
                    :format="'YYYY-MM-DD'"
                    :formatted="'YYYY-MM-DD'"
                    :range="false"
                    :auto-close="true"
                    :only-date="true"
                    :no-header="true"
                    @input="actualizar()"
                    style="position: fixed;width: 180px"
                />

              </div>

            </div>
            <div class="row">
              <button type="button" class="btn btn-primary m-2"
                      v-on:click="abrirCarga"
                      v-show="$can('cuaderno-obra-agregar')" >
                Cargar fotos
              </button>
            </div>
            <div class="row font-size-12">
              <table class="table">
                <thead>
                <th>ID</th>
                <th>Archivos</th>
                <th>Op</th>
                </thead>
                <tbody>
                <tr v-for="(row,index) in model.archivos"  v-bind:key="index">
                  <td>
                    {{ row.id }}
                  </td>
                  <td>
                    <a :href="server + '/storage/' + row.nombre"  target="_blank" >
                      <img :src="server + '/image/' + row.nombre" style="max-width: 200px; height: auto; " />
                    </a>

                  </td>
                  <td>
                    <button v-if="$can('cuaderno-obra-eliminar')"
                        class="btn btn-danger btn-icon btn-sm ml-1"
                        v-on:click="borrarArchivo(row.id)" >
                      <i class="fa fa-trash"></i>
                    </button>
                  </td>
                </tr>
                </tbody>
              </table>

            </div>


            <b-modal
                id="modalUpload"
                scrollable
                title="Subir archivo"
                title-class="font-18"
                size="lg"
                no-close-on-esc
                hide-footer
                centered
            >
              <subirArchivos v-on:upload-complete="uploadComplete" />
            </b-modal>
          </div>
        </b-overlay>

    </div>
  </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import subirArchivos from "@/components/subir-archivos";


/* eslint-disable vue/no-unused-components */

//import constantes from "../../../config/Constantes";
/**
 * Dashboard Component
 */
export default {
  page: {
    title: "Avance",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {
    Layout,
    //PageHeader,
    subirArchivos,


  },
  data() {
    return {
      server:process.env.VUE_APP_BACKEND,

      title: "Avance",
      items: [
        {
          text: "Avance",
          href: "/"
        },
        {
          text: "Lista",
          active: true
        }
      ],
      isLoading: false,

      expedientes:[],
      expediente_id:null,

      fecha:null,
      context:null,
      model:{}

    };
  },

  methods: {
    uploadComplete(files){
      this.isLoading=true;
      this.axios.post(process.env.VUE_APP_BACKEND + "/api/cuaderno-obra/archivos",
          {
            files:files,
            expediente_id:this.expediente_id,
            fecha:this.fecha
          })
          .then(()=>{
            this.$bvModal.hide("modalUpload");
            this.actualizar();
          })
          .finally(()=>this.isLoading=false)

    },
    abrirCarga(){
      this.$bvModal.show("modalUpload");
    },
    actualizar(){
      this.isLoading=true;
      this.axios.get(process.env.VUE_APP_BACKEND + "/api/cuaderno-obra/archivos",
          {
            'params':{
              'expediente_id':this.expediente_id,
              'fecha':this.fecha
            }
          }
      )
          .then((response)=>{
            this.model=response.data;
          })
          .catch(()=>{
            this.$swal('Cuidado','Error accediendo al registro de cuaderno de obra','warning');
          })
          .finally(()=>this.isLoading=false)

    },
    cargarExpedientes(){
      this.isLoading=true;
      this.axios.get(process.env.VUE_APP_BACKEND + "/api/expedientes")
          .then((response)=>{
            this.expedientes=response.data;
          })
          .catch(()=>{
            this.$swal('Cuidado',"Error cargando los expedientes",'warning');
          })
          .finally(()=>this.isLoading=false)
    },
    borrarArchivo(id){
      this.$swal.fire({
        title: '¿Esta seguro de eliminar esta foto?',
        text: "",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'Si, borralo!'
      }).then((result) => {
        if (result.value) {
          this.isLoading=true;
          this.axios.delete(process.env.VUE_APP_BACKEND +'/api/cuaderno-obra/'+this.model.id+'/archivos/'+id)
              .catch(()=>{
                this.$swal('error','Error eliminando','error');
              })
              .finally(
                  ()=>
                  {
                    this.isLoading=false;
                    this.actualizar();
                  }
              );
        }
      })
    }

  },
  watch:{

  },
  computed:{

  },
  beforeMount() {
    this.context = { componentParent: this };

  },
  validations: {

  },

  mounted() {
    var date= new Date();
    this.fecha=new Date(date.getTime() - (date.getTimezoneOffset() * 60000)).toISOString().substring(0, 10)
    this.cargarExpedientes();
  },
};
</script>

<style>
</style>